import { memo } from 'react';
import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { breakpoints, Button, Text, textVariants } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { seatButtonStyles } from '../../utils/styles';
import { getSeatId } from '../../utils/seatIdUtils';
import useDarkMode from '../../../custom-hooks/useDarkMode';
import SeatTooltip from './SeatTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectedSeatInitialsStyles = {
  base: css`
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;
  `,
  blackColor: css`
    color: #000;
  `
};
const BookableSeat = ({
  carrier,
  column,
  isRyanairInTrip,
  isSelected,
  markup,
  onChange,
  price,
  row,
  seat,
  SeatIcon,
  seatTypeLabel,
  selectedSeatInitials
}) => {
  const {
    t
  } = useTranslation();
  const {
    isDarkMode
  } = useDarkMode();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._1170})`);
  const id = getSeatId(row, seat);
  const formattedPrice = priceUtil.formatPrice(price);
  const markupLabel = t('Product.Markup.Label');
  const priceBreakdownLabel = t('ScreenReader.Product.Pricebreakdown.Label');
  const seatLabel = t('OrderDetails.Passenger.Drawer.Seat.Title');
  const selectedActionLabel = t('ScreenReader.Seatmap.Seat.Selected.Action');
  const buttonAriaLabel = () => {
    if (isRyanairInTrip && carrier) {
      var _markup$value;
      const normalizedMarkup = typeof markup === 'number' ? markup : (_markup$value = markup === null || markup === void 0 ? void 0 : markup.value) !== null && _markup$value !== void 0 ? _markup$value : 0;
      const markupPrice = priceUtil.formatPrice(normalizedMarkup);
      const providerPrice = priceUtil.formatPrice(price - normalizedMarkup);
      const priceBreakdownText = t('Product.Carrier.PriceBreakdown.Text', `${carrier.name} ${providerPrice}`, `${markupLabel} ${markupPrice}`);
      return `${seatTypeLabel}. ${seatLabel} ${seat}: ${formattedPrice}. ${priceBreakdownLabel}: ${priceBreakdownText}`;
    }
    return `${seatTypeLabel}. ${seatLabel} ${seat}: ${formattedPrice}`;
  };
  return /*#__PURE__*/_jsxs(Button, {
    "aria-label": buttonAriaLabel(),
    className: seatButtonStyles,
    "data-seat-id": id,
    "data-selected": isSelected,
    "data-testid": id,
    "data-tooltip-id": id,
    onClick: () => onChange({
      price,
      carrier,
      column,
      row,
      seat,
      markup
    }),
    children: [isSelected && /*#__PURE__*/_jsx(Text, {
      "aria-label": selectedActionLabel,
      className: cx(selectedSeatInitialsStyles.base, {
        [selectedSeatInitialsStyles.blackColor]: isDarkMode
      }),
      variant: textVariants._12_BOLD,
      children: selectedSeatInitials
    }), SeatIcon && /*#__PURE__*/_jsx(SeatIcon, {
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsx(SeatTooltip, {
      carrier: isRyanairInTrip ? carrier : undefined,
      id: id,
      isDesktop: isDesktop,
      markup: markup,
      price: price,
      seat: seat
    })]
  });
};
export default /*#__PURE__*/memo(BookableSeat);
//# sourceMappingURL=BookableSeat.js.map